var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./Monaco.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-04475a37!../node_modules/vue-loader/lib/selector?type=template&index=0!./Monaco.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Monaco.vue
// module id = 48
// module chunks = 0